import { render, staticRenderFns } from "./BMultipleOptionSelection.vue?vue&type=template&id=5e7a4aa8&"
import script from "./BMultipleOptionSelection.vue?vue&type=script&lang=js&"
export * from "./BMultipleOptionSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports